import { Attributes, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import CommissionType from './CommissionType';
import AuthorisationValues from '../../ValueObjects/AuthorisationValues';
import { IAuthorisable } from '../../IAuthorisable';

@NeoModel
export default class CommissionRate extends ModelBase implements IAuthorisable {
    static typeName = "CommissionRate";

    public commissionRateId: number = 0;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public commissionTypeId: number | null = null;

    @Attributes.Parent(() => CommissionType)
    public commissionType: CommissionType | null = null;

    @Attributes.Float()
    @Attributes.Display("Commission Rate")
    public commissionRateValue: number = 0.00;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public commissionRateDate: Date | null = null;

    @Attributes.ChildObject(AuthorisationValues, true)
    public authorisation: AuthorisationValues = new AuthorisationValues();

    public isPendingDelete: boolean = false;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New commission rate";
        } else {
            return "Commission Rate";
        }
    }
}